import React from "react";
import FieldError from "../registration/FieldError";

function EmissionTravelSection({
  language,
  airTravel,
  setAirTravel,
  travelTime,
  setTravelTime,
  eventTransport,
  setEventTransport,
  kmLand,
  setKmLand,
  setStoredValue,
  formErrors,
  eventTransports,
}) {
  const t = {
    EN: {
      airTravel: "Did you arrive by plane?",
      flightHours: "How many hours did you fly?",
      transport: "How will you get to the event?",
      distance: "Approximately how many km will you travel to get to the event?",
      selectOption: "Select an option",
      selectHours: "Select hours",
      selectTransport: "Select a transport method",
      selectKm: "Select a distance",
      yes: "Yes",
      no: "No",
      hours: "hours",
      kmOptions: [
        ["3", "Between 0 and 5 km"],
        ["8", "Between 5 and 10 km"],
        ["15", "Between 10 and 20 km"],
        ["25", "Between 20 and 30 km"],
        ["35", "Between 30 and 40 km"],
        ["45", "Between 40 and 50 km"],
        ["75", "Between 50 and 100 km"],
        ["150", "Between 100 and 200 km"],
        ["300", "Between 200 and 400 km"],
        ["500", "More than 400 km"],
      ],
    },
    ES: {
      airTravel: "¿Llegaste en avión?",
      flightHours: "¿Cuántas horas volaste?",
      transport: "¿En qué transporte vas a llegar al evento?",
      distance: "Aproximadamente ¿cuántos km vas a recorrer para llegar al evento?",
      selectOption: "Seleccioná una opción",
      selectHours: "Seleccioná una cantidad de hs",
      selectTransport: "Seleccioná un medio de transporte",
      selectKm: "Seleccioná una cantidad de kms",
      yes: "Sí",
      no: "No",
      hours: "horas",
      kmOptions: [
        ["3", "Entre 0 y 5 KM"],
        ["8", "Entre 5 y 10 KM"],
        ["15", "Entre 10 y 20 KM"],
        ["25", "Entre 20 y 30 KM"],
        ["35", "Entre 30 y 40 KM"],
        ["45", "Entre 40 y 50 KM"],
        ["75", "Entre 50 y 100 KM"],
        ["150", "Entre 100 y 200 KM"],
        ["300", "Entre 200 y 400 KM"],
        ["500", "Más de 400"],
      ],
    },
  };

  const flightHours = [
    "0.5",
    "1",
    "1.5",
    "2",
    "2.5",
    "3",
    "3.5",
    "4",
    "4.5",
    "5",
    "5.5",
    "6",
    "6.5",
    "7",
    "7.5",
    "8",
    "8.5",
    "9",
    "9.5",
    "10",
  ];

  return (
    <>
      <div className="containerFlex">
        <div className="col-2">
          <label>
            {t[language].airTravel} <b>*</b>
          </label>
          <select
            value={airTravel}
            onChange={(e) => {
              const value = e.target.value;
              setAirTravel(value);
              setStoredValue("air_travel", value);

              if (value === "0") {
                setTravelTime("");
                setStoredValue("travel_time", "0");
              } else {
                setTravelTime("");
                setStoredValue("travel_time", "");
              }
            }}
          >
            <option value="" disabled>
              {t[language].selectOption}
            </option>
            <option value="1">{t[language].yes}</option>
            <option value="0">{t[language].no}</option>
          </select>
          <FieldError error={formErrors.airTravel} />
        </div>

        <div className="col-2">
          <label>
            {t[language].flightHours} <b>*</b>
          </label>
          <select
            value={travelTime}
            name="travel_time"
            onChange={(e) => {
              const value = e.target.value;
              setTravelTime(value);
              setStoredValue("travel_time", value);
            }}
            disabled={airTravel !== "1"}
            required={airTravel === "1"}
          >
            <option value="" disabled>
              {t[language].selectHours}
            </option>
            {flightHours.map((hour) => (
              <option key={hour} value={hour}>
                {hour} {t[language].hours}
              </option>
            ))}
          </select>
          <FieldError error={formErrors.travelTime} />
        </div>
      </div>

      <div className="containerFlex">
        <div className="col-2">
          <label>
            {t[language].transport} <b>*</b>
          </label>
          <select
            value={eventTransport}
            name="transport"
            onChange={(e) => {
              const value = e.target.value;
              setEventTransport(value);
              setStoredValue("event_transport", value);
            }}
            required
          >
            <option value="" disabled>
              {t[language].selectTransport}
            </option>
            {eventTransports.map((mode) => (
              <option key={mode.value} value={mode.value}>
                {mode.label}
              </option>
            ))}
          </select>
          <FieldError error={formErrors.eventTransport} />
        </div>

        <div className="col-2">
          <label>
            {t[language].distance} <b>*</b>
          </label>
          <select
            value={kmLand}
            name="km_land"
            onChange={(e) => {
              const value = e.target.value;
              setKmLand(value);
              setStoredValue("km_land", value);
            }}
            required
          >
            <option value="" disabled>
              {t[language].selectKm}
            </option>
            {t[language].kmOptions.map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
          <FieldError error={formErrors.kmLand} />
        </div>
      </div>
    </>
  );
}

export default EmissionTravelSection;
